import React from 'react';
import styles from './LiveStats.module.scss';
import { T } from '@colonist/ui';
export const LiveStats = ({ playersOnline, gamesToday })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.liveStats
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.value
    }, playersOnline.toLocaleString()), /*#__PURE__*/ React.createElement("span", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:liveStats.online"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.stat
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.value
    }, gamesToday.toLocaleString()), /*#__PURE__*/ React.createElement("span", {
        className: styles.label
    }, /*#__PURE__*/ React.createElement(T, {
        id: "strings:liveStats.gamesToday",
        options: {
            count: gamesToday
        }
    }))));
